/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPublicTabletServicesQueryResponse, GetApiPublicTabletServicesQueryParams, GetApiPublicTabletServices400, GetApiPublicTabletServices403, GetApiPublicTabletServices404, GetApiPublicTabletServices500 } from "../entities/GetApiPublicTabletServices";

function getGetApiPublicTabletServicesUrl() {
  const res = { method: 'GET', url: `/api/public/tablet/services` as const }
  return res
}

/**
 * @description Активные неудалённые услуги компании выбранного доступного филиала
 * @summary Получить услуги для планшета
 * {@link /api/public/tablet/services}
 */
export async function getApiPublicTabletServices(params: GetApiPublicTabletServicesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiPublicTabletServicesQueryResponse, ResponseErrorConfig<GetApiPublicTabletServices400 | GetApiPublicTabletServices403 | GetApiPublicTabletServices404 | GetApiPublicTabletServices500>, unknown>({ method : "GET", url : getGetApiPublicTabletServicesUrl().url.toString(), params, ... requestConfig })
  return res.data
}